import { Pipe, PipeTransform, NgModule } from '@angular/core';

@Pipe({ name: 'ordinal', standalone: false })
export class OrdinalPipe implements PipeTransform {
  /**
   * Converts a number to its ordinal string (1st, 2nd, 3rd, etc.)
   * @param input - The number to convert
   * @returns Ordinal string representation
   */
  transform(input: number): string {
    if (!isFinite(input)) {
      return 'NaN';
    }
    const str = input.toString();
    const beforeLastDigit = str.charAt(str.length - 2);
    if (beforeLastDigit === '1') {
      return input + 'th';
    }
    const cardinal = str.charAt(str.length - 1);
    switch (cardinal) {
      case '1': return input + 'st';
      case '2': return input + 'nd';
      case '3': return input + 'rd';
      default: return input + 'th';
    }
  }
}

@NgModule({
  declarations: [OrdinalPipe],
  exports: [OrdinalPipe],
})
export class NgOrdinalPipeModule {}
